import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 检查本地存储的 token
    const token = localStorage.getItem('token');
    if (token) {
      fetchUser(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUser = async (token) => {
    try {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await api.get('/api/users/me');
      setUser(response.data.user);
      
      // 获取会员状态并保存到 localStorage
      try {
        const membershipRes = await api.get('/api/membership/status');
        if (membershipRes.data) {
          localStorage.setItem('membership', JSON.stringify({
            plan: membershipRes.data.plan || 'free',
            is_member: membershipRes.data.is_member,
            expires_at: membershipRes.data.expires_at
          }));
        }
      } catch (e) {
        console.error('获取会员状态失败:', e);
        localStorage.setItem('membership', JSON.stringify({ plan: 'free' }));
      }
    } catch (error) {
      localStorage.removeItem('token');
      delete api.defaults.headers.common['Authorization'];
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await api.post('/api/auth/login', { email, password });
    const { user, token } = response.data;
    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(user);
    return user;
  };

  const register = async (userData) => {
    const response = await api.post('/api/auth/register', userData);
    const { user, token } = response.data;
    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(user);
    return user;
  };

  const loginPhone = async (phone, code, password) => {
    const payload = { phone };
    if (password) payload.password = password;
    if (code) payload.code = code;
    const response = await api.post('/api/auth/login-phone', payload);
    const { user, token } = response.data;
    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(user);
    return user;
  };

  const registerPhone = async (userData) => {
    const response = await api.post('/api/auth/register-phone', userData);
    const { user, token } = response.data;
    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(user);
    return user;
  };

  const sendSmsCode = async (phone, type = 'register') => {
    const response = await api.post('/api/auth/send-sms-code', { phone, type });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, loginPhone, registerPhone, sendSmsCode, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
